//uat
// export const baseUrl = "https://uathelp.tataplay.com/recharge";

//Prod
export const baseUrl = "https://unifiedbot.tataplay.com/recharge";

//dev
// export const baseUrl = "https://uathelp.tataplay.com/recharge-dev";
